goog.provide('el8.app.shared.dialog.plr4EveryoneFirstSignInFTUX');

goog.require('el8.data.practiceSettings');
goog.require('el8.data.practiceUsers');
goog.require('el8.service.urls');
goog.require('el8.template.app.shared.dialog.plr4EveryoneFirstSignInFTUX');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.util.consts');

/**
 * FTUX for after we open an unverified patient that came in through PLR4Everyone invite
 */
el8.app.shared.dialog.plr4EveryoneFirstSignInFTUX = (function() {

    var submitForm = null;
    var that = new el8.uiwidget.NewDialog({
        title: "Introducing the Elation Collaborative View",
        modal: true,
        autoHeight: true,
        width: 500,
        showXButton: true,
        contentFn: function() {
            return el8.template.app.shared.dialog.plr4EveryoneFirstSignInFTUX.content({});
        }
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        var elt = that.getContentElt();

        if (el8.data.currPractice.isPracticingEmr()) {
            if (el8.data.practiceSettings.isHasSetAutoShareStatus()) {
                if (el8.data.practiceSettings.isAutoShareIntoPlr()) {
                    $('.content-section', elt).html(el8.template.app.shared.dialog.plr4EveryoneFirstSignInFTUX.userSharingYes());
                    $('.acknowledge-trigger', elt).show();
                } else {
                    $('.content-section', elt).html(el8.template.app.shared.dialog.plr4EveryoneFirstSignInFTUX.userSharingNo());
                    $('.acknowledge-trigger', elt).show();
                }
            } else {
                if (el8.data.currUser.isPracticeAdmin()) {
                    $('.content-section', elt).html(el8.template.app.shared.dialog.plr4EveryoneFirstSignInFTUX.adminNoPreferenceSet());
                    $('.submit-trigger', elt).show();
                    $('.ask-later-trigger', elt).show();
                }
            }
        } else {
            $('.content-section', elt).html(el8.template.app.shared.dialog.plr4EveryoneFirstSignInFTUX.passportPrompt());
            $('.acknowledge-passport-trigger', elt).show();
        }

        submitForm = new el8.uiwidget.Form({
            container: $('.auto-share-form', that.getContentElt()),
            fields: [
                {
                    name: 'autoShare',
                    selector: ':input[name="autoShare"]'
                }
            ]
        });
        submitForm.render();
        that.adjustPosition();
        bindTriggers();
    };

    function bindTriggers() {
        that.getContentElt().on('click', '.acknowledge-trigger',  function(e) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('ftue', [el8.data.currUser.getId(),'PLR4Everyone']),
            });
            that.hide();
        }).on('click', '.acknowledge-passport-trigger',  function(e) {
            el8.data.practiceSettings.updateAutoShareIntoPlr(true, function(data) {
                $.el8_ajax({
                    type: 'POST',
                    url: el8.service.urls.get('careTeamEnableAllSharing', []),
                    success: function(data) {
                        $.el8_ajax({
                            type: 'POST',
                            url: el8.service.urls.get('ftue', [el8.data.currUser.getId(),'PLR4Everyone']),
                        });
                    }
                });
            });
            that.hide();
        }).on('click', '.ask-later-trigger',  function(e) {
            that.hide();
        }).on('click', '.submit-trigger',  function(e) {
            var elt = that.getContentElt();
            var auto_share = parseInt(submitForm.getVal('autoShare'), 10);

            submitForm.disable();
            el8.data.practiceSettings.updateAutoShareIntoPlr(auto_share, function(data) {
                el8.data.practiceSettings.updateHasSetAutoShareStatus(true, function(data) {
                    $('.submit-trigger', elt).hide();
                    $('.ask-later-trigger', elt).hide();
                    $('.dismiss-trigger', elt).show();
                    submitForm.enable();
                    if (auto_share) {
                        $('.content-section', elt).html(el8.template.app.shared.dialog.plr4EveryoneFirstSignInFTUX.adminSetSharingYes());

                        // also turn on sharing for all existing charts
                        $.el8_ajax({
                            type: 'POST',
                            url: el8.service.urls.get('careTeamEnableAllSharing', [])
                        });
                    } else {
                        $('.content-section', elt).html(el8.template.app.shared.dialog.plr4EveryoneFirstSignInFTUX.adminSetSharingNo());
                    }
                    that.adjustPosition();
                });
            });
            that.adjustPosition();
        }).on('click', '.dismiss-trigger',  function(e) {
            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('ftue', [el8.data.currUser.getId(),'PLR4Everyone']),
            });
            that.hide();
        });
    }

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        super_show.call(that);
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
    };

    return that;
})();
